var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-view-wrapper pd-10"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"sectionWrapper",staticClass:"content-view section-wrapper",attrs:{"element-loading-background":_vm.loadingBackground}},[_c('section',{staticClass:"container"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }